module.exports = __webpack_public_path__ + "media/images/favicons/favicon-thursday-16x16-29e0892a29569ff9ee358df413d2cfe1.png";